const enum AppEnv {
  Development = `development`,
  Production = `production`,
  Test = `test`,
}

function getAppEnv(): string {
  return typeof APP_ENV !== `undefined` ? APP_ENV : AppEnv.Development;
}

export function isDevEnv(): boolean {
  return getAppEnv() === AppEnv.Development;
}

export function isTestEnv(): boolean {
  return getAppEnv() === AppEnv.Test;
}

export function isProdEnv(): boolean {
  return getAppEnv() === AppEnv.Production;
}

export function isBrowserEnv(): boolean {
  return typeof window !== `undefined`;
}

export function isStandalone(): boolean {
  return typeof mp === `undefined`;
}

export function isLocalOrigin(): boolean {
  // temp: treat codespaces as local environment for standalone iron dev. will remove when we have nginx
  return (
    [`localhost`, `127.0.0.1`].includes(window.location.hostname) ||
    window.location.hostname.endsWith(`.app.github.dev`)
  );
}

export function isLocalhostDevEnv() {
  return isBrowserEnv() && isDevEnv() && isLocalOrigin();
}

export function isMixpanelDotCom() {
  if (!isBrowserEnv()) {
    return false;
  }
  const domain = window.location.hostname;
  return /\bmixpanel\.com$/.test(domain);
}

// mockable export
export const envUtils = {isProdEnv, isTestEnv};
